import $ from 'jquery';

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import {
	CSS2DRenderer,
	CSS2DObject,
} from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import feather from 'feather-icons';
import Hammer from 'hammerjs';
import hotspotsDataArray from './hotspotsDataArray.js';
import Stats from 'stats-js';

gsap.registerPlugin(ScrollTrigger);
feather.replace();

class Hotspot {
	constructor(x, y, z, name, animation, info, mobileAnimation) {
		this.x = x;
		this.y = y;
		this.z = z;
		this.name = name;
		this.animation = animation;
		this.info = info;
		this.mobileAnimation = mobileAnimation;

		this.geometry = new THREE.PlaneGeometry(0);
		this.material = new THREE.MeshBasicMaterial({
			transparent: true,
			opacity: 0,
			side: THREE.DoubleSide,
		});
		this.plane = new THREE.Mesh(this.geometry, this.material);
		this.plane.name = this.name;
		var translateX = base.position.x + this.x;
		var translateY = base.position.y + this.y;
		var translateZ = base.position.z + this.z;
		this.plane.position.set(translateX, translateY, translateZ);
		this.plane.rotation.set(0, 0, 0);
		this.plane.lookAt(camera.position);
		scene.add(this.plane);
		this.labelDiv = document.createElement('div');
		this.labelDiv.className = 'hs-label magnetic-wrap';
		this.labelDiv.textContent = this.name;
		this.labelDiv.setAttribute('data-spot', this.name);
		this.labelDiv.style.marginTop = '-1em';
		this.labelDiv.addEventListener('click', this.onClick.bind(this));
		this.labelDiv.innerHTML = `
            <div class="magnetic"> 
                <div class="c">
                    <i data-feather="plus" stroke-width="1.5" color="#ffffff"></i> 
                    <span class="hs-name">${name}</span>    
                </div>
            </div> 
        `;

		this.label = new CSS2DObject(this.labelDiv);
		this.label.position.set(
			this.plane.position.x,
			this.plane.position.y,
			this.plane.position.z
		);
		scene.add(this.label);
	}

	onClick() {
		var name = $(this.labelDiv).parent().parent().attr('data-spot');
		var id = name;

		resetCamPos();

		moveMultiplier = 0;
		gsap.to(camera.position, {
			x: 0,
			y: 0,
			z: 2,
			duration: 0.1,
			onComplete: function () {
				camera.position.set(0, 0, 2);
			},
		});

		gsap.to('.info', {
			ease: ease,
			onStart: function () {
				$('.info').addClass('info-out');
			},
		});

		$('body').addClass('limit-scroll');

		gsap.to('.hide-on-focus', {
			opacity: 0,
			duration: 0.5,
			ease: ease,
		});

		if (isMobile) {
			$('body').addClass('limit-scroll');
			gsap.to('.webgl-c', {
				duration: dur,
				y: '-25%',
				onComplete: function () {},
				ease: ease,
			});
		} else {
			gsap.to('.webgl-c', {
				duration: dur,
				x: '-25%',
				onComplete: function () {},
				ease: ease,
			});
		}

		gsap.to('.hs-label', {
			duration: dur - 0.5,
			opacity: 0,
			ease: ease,
			onStart: function () {
				$('.hs-label').css('pointer-events', 'none');
			},
		});

		$('#i_head').html(this.info.hl);
		$('#i_para').html(this.info.text);
		$('#i_img').css('display', 'block');
		$('#i_vid').css('display', 'none');
		if (this.info.isVideo) {
			$('#i_img').css('display', 'none');
			$('#i_vid').css('display', 'block');
			$('#i_vid').attr('src', `${this.info.imgSrc}`);
		} else {
			$('#i_vid').css('display', 'none');
			$('#i_img').attr('src', `${this.info.imgSrc}`);
		}

		if (this.info.link) {
			$('#i_link').attr('href', `${this.info.link}`);
			$('#i_link').css('display', 'block');
		} else {
			$('#i_link').css('display', 'none');
		}

		if (this.info.sec) {
			$('#i_sec').html(this.info.sec.title);
			$('#i_sec').attr('href', `${this.info.sec.link}`);
			$('#i_sec').css('display', 'block');
		} else {
			$('#i_sec').css('display', 'none');
		}

		if (this.info.more) {
			const container = document.getElementById('i_more');
			container.innerHTML = '';
			const div = document.createElement('div');
			div.style.display = 'flex';
			div.style.flexWrap = 'wrap';
			div.style.marginTop = '20px';
			div.style.gap = '20px';
			const h3 = document.createElement('h3');
			h3.style.opacity = '0.75';
			h3.textContent = this.info.more.title;
			container.appendChild(h3);

			this.info.more.buttons.forEach((button) => {
				const a = document.createElement('a');
				a.href = button.link;
				a.target = '_blank';
				a.style.marginTop = '0px';
				a.textContent = button.text;
				div.appendChild(a);
			});

			container.appendChild(div);
		} else {
			const container = document.getElementById('i_more');
			container.innerHTML = '';
		}

		if (isMobile) {
			gsap.to(base.rotation, {
				duration: dur,
				x: this.mobileAnimation.rotation.x,
				y: this.mobileAnimation.rotation.y,
				z: this.mobileAnimation.rotation.z,
				ease: ease,
			});
			gsap.to(base.position, {
				duration: dur,
				x: this.mobileAnimation.position.x,
				y: this.mobileAnimation.position.y,
				z: this.mobileAnimation.position.z,
				ease: ease,
			});
			gsap.to(camera.position, {
				duration: dur,
				x: 0,
				y: 0,
				z: 2,
				ease: ease,
			});
			gsap.to(camera.rotation, {
				duration: dur,
				x: 0,
				y: 0,
				z: 0,
				ease: ease,
			});
		} else {
			gsap.to(base.rotation, {
				duration: dur,
				x: this.animation.rotation.x,
				y: this.animation.rotation.y,
				z: this.animation.rotation.z,
				ease: ease,
			});
			gsap.to(base.position, {
				duration: dur,
				x: this.animation.position.x,
				y: this.animation.position.y,
				z: this.animation.position.z,
				ease: ease,
			});
			gsap.to(camera.position, {
				duration: dur,
				x: camera_default_pos[0],
				y: camera_default_pos[1],
				z: camera_default_pos[2],
				ease: ease,
			});
			gsap.to(camera.rotation, {
				duration: dur,
				x: 0,
				y: 0,
				z: 0,
				ease: ease,
			});
		}
	}
}

var scene, camera, renderer, labelRenderer, base;
var l_spot_1;

var camera_default_pos = [0, 1, 2],
	camera_default_rot = [0, 0, 0];

var base_default_pos = [0, -0.25, 0],
	base_default_rot = [0, 0, 0];

var isMobile = false;
checkIfMobile();
var isMobilePrev = isMobile;

var mobileScrolledX = -1;

var windowHalf;

var moveMultiplier = 2.5;

function checkIfMobile() {
	if (window.innerWidth < 1000) {
		isMobile = true;
		camera_default_pos = [-1, 0.85, 2];
		base_default_pos = [0, 0.75, 0.5];
	} else {
		isMobile = false;
		camera_default_pos = [0, 1, 2];
		base_default_pos = [0, -0.25, 0];
	}
}

var model_loaded = false,
	loading_progrss = 0,
	loading_progrss_model = 0,
	loading_progrss_hdr = 0,
	threeD_folder = '../assets/threeD/models/',
	hdr_file = '3.hdr',
	model_file = 'hotspotobjekt08032023.glb',
	scaleFaktor = 2.5;

var ease_name = 'power4',
	ease_type = 'inOut',
	cnvs,
	ease = `${ease_name}.${ease_type}`,
	dur = 1.5;

scene = new THREE.Scene();

camera = new THREE.PerspectiveCamera(
	50,
	window.innerWidth / window.innerHeight,
	0.1,
	1000
);

camera.position.set(
	camera_default_pos[0],
	camera_default_pos[1],
	camera_default_pos[2]
);

renderer = new THREE.WebGLRenderer({
	antialias: true,
	alpha: true,
});

function resetCamPos() {
	camera.position.set(
		camera_default_pos[0],
		camera_default_pos[1],
		camera_default_pos[2]
	);
	cursor = {
		x: 0,
		y: 0,
	};
}

const stats = new Stats();
stats.showPanel(0);

renderer.setSize(window.innerWidth, window.innerHeight);
document.querySelector('.webgl-c').appendChild(renderer.domElement);
renderer.domElement.classList.add('webgl');
renderer.setPixelRatio(window.devicePixelRatio);

renderer.physicallyCorrectLights = true;

renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.shadowMap.autoUpdate = true;
renderer.shadowMap.needsUpdate = true;

renderer.unsignedByteType = true;
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMappingExposure = 1;

labelRenderer = new CSS2DRenderer();

labelRenderer.domElement.setAttribute('id', 'label-c');
labelRenderer.domElement.classList.add('label-container');
labelRenderer.setSize(window.innerWidth, window.innerHeight);
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = '0px';
labelRenderer.domElement.style.opacity = '0';
document.querySelector('.webgl-c').appendChild(labelRenderer.domElement);

base = new THREE.Object3D();
base.position.set(
	base_default_pos[0],
	base_default_pos[1],
	base_default_pos[2]
);
scene.add(base);

const l_ambi_1 = new THREE.AmbientLight(0xffffff, 1);
scene.add(l_ambi_1);

const l_point_1 = new THREE.PointLight(0xffffff, 1, 10, 2);
l_point_1.position.set(1, 0.5, 0.5);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
directionalLight.position.set(0, 5, 10);
directionalLight.lookAt(0, 0, 0);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.width = 1024;
directionalLight.shadow.mapSize.height = 1024;
directionalLight.shadow.normalBias = 0.05;

scene.add(directionalLight);

const rotateThis = new THREE.Object3D();
base.add(rotateThis);

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('../draco/');

const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

new RGBELoader().setPath(threeD_folder).load(
	hdr_file,
	function (texture) {
		texture.mapping = THREE.EquirectangularReflectionMapping;

		scene.environment = texture;

		const gltfLoader = new GLTFLoader();
		gltfLoader.setDRACOLoader(dracoLoader);

		gltfLoader.setPath(threeD_folder).load(
			model_file,
			function (gltf) {
				const model = gltf.scene;

				model.traverse(function (child) {
					if (child.isMesh) {
						child.castShadow = true;
						child.receiveShadow = true;

						child.material.envMap = texture;
						child.material.envMapIntensity = 0.75;
						child.material.needsUpdate = true;
						child.material.roughness -= 0.05;

						child.material.shadow -= 0.01;

						if (child.material.name === 'aluminum.matt') {
							child.material.roughness = 0.3;
							child.material.metalness = 0.8;
							child.material.color = new THREE.Color(0x464242);
						}
						if (child.material.name === 'aluminum') {
							child.material.roughness = 0.16;
						}
						if (child.material.name === 'yellow') {
							child.material.roughness = 0.15;
							child.material.metalness = 0.8;
							child.material.color = new THREE.Color(0x464242);
						}
					}
				});

				const opacityObjects = ['Einbaukontur', 'Kugellager', 'KABEL'];

				const opacityMaterial = new THREE.MeshBasicMaterial({
					transparent: true,
					opacity: 0.05,
					color: 0x000000,
				});
				opacityObjects.forEach((obj) => {
					model.getObjectByName(obj).traverse((o) => {
						if (o.isMesh) o.material = opacityMaterial;
					});
				});

				const powercheck = model.getObjectByName('POWERCHECK');

				powercheck.traverse((o) => {
					if (o.isMesh) {
						if (o.material.name === 'black.map.001') {
							o.material.roughness = 0.25;
							o.material.metalness = 0.7;
						}
					}
				});

				base.add(model);
			},
			function (xhr) {
				loading_progrss_model = ((xhr.loaded / xhr.total) * 100) / 2;

				if ((xhr.loaded / xhr.total) * 100 >= 100) {
					model_loaded = true;
				}
			},
			function (e) {
				console.error(e);
			}
		);

		base.scale.set(scaleFaktor, scaleFaktor, scaleFaktor);
	},
	function (xhr) {
		loading_progrss_hdr = ((xhr.loaded / xhr.total) * 100) / 2;
	},
	function (e) {
		console.error(e);
	}
);

hotspotsDataArray.forEach(function (hs) {
	new Hotspot(
		hs.x,
		hs.y,
		hs.z,
		hs.name,
		hs.animateTo,
		hs.info,
		hs.mobileAnimateTo
	);
});

const backgroundPlane = new THREE.Mesh(
	new THREE.PlaneGeometry(2, 2),
	new THREE.MeshStandardMaterial({
		color: 0x000000,
	})
);
backgroundPlane.position.set(0, 0, -2);

windowHalf = new THREE.Vector2(window.innerWidth / 2, window.innerHeight / 2);
let cursor = {
	x: 0,
	y: 0,
};

document.addEventListener('mousemove', (event) => {
	cursor.x = (event.clientX / window.innerWidth) * 2 - 1;
	cursor.y =
		(event.clientY / (window.innerHeight + window.innerHeight / 3)) * 2 - 1;
	cursor.x *= moveMultiplier;
	cursor.y *= moveMultiplier;
});

const loadingInterval = setInterval(() => {
	$('.display-loading-progress').text(Math.round(loading_progrss) + '%');
}, 10);

function animate() {
	requestAnimationFrame(animate);

	loading_progrss = loading_progrss_hdr + loading_progrss_model;
	if (loading_progrss >= 100 && model_loaded) {
		$('.display-loading-progress').text('100%');
		clearInterval(loadingInterval);
	}

	if (!isMobile) {
		var moveX = cursor.x - camera.position.x;
		var moveY = cursor.y - camera.position.y;
		gsap.to(camera.position, {
			duration: 1,
			x: moveX * 0.2,
			y: moveY * 0.2,
		});
		camera.lookAt(0, 0, 0);
	}

	if (isMobile) {
		$('.info').removeClass('info-landscape');
		$('.info').addClass('info-mobile');
		if (camera.position.x < -1) {
			gsap.to(camera.position, {
				duration: 0.25,
				x: -1,
				ease: 'none',
			});
		} else if (camera.position.x > 1) {
			gsap.to(camera.position, {
				duration: 0.25,
				x: 1,
				ease: 'none',
			});
		}

		if (camera.position.x <= -0.25) {
			gsap.to('.scroll-trailer', {
				duration: 1,
				opacity: 1,
				ease: 'power4.out',
			});
		} else {
			gsap.to('.scroll-trailer', {
				duration: 1,
				opacity: 0,
				ease: 'power4.out',
			});
		}
	} else {
		$('.info').addClass('info-landscape');
		$('.info').removeClass('info-mobile');
	}

	stats.begin();

	stats.end();

	rotateThis.rotation.x += 0.01;

	renderer.render(scene, camera);

	labelRenderer.render(scene, camera);
}

window.addEventListener('resize', function () {
	camera.aspect = window.innerWidth / window.innerHeight;
	renderer.setSize(window.innerWidth, window.innerHeight);
	camera.updateProjectionMatrix();
	labelRenderer.setSize(window.innerWidth, window.innerHeight);

	if (isMobile != isMobilePrev) {
		location.reload();
	}
});

function entry_loaded_check() {
	if (model_loaded == true) {
		setTimeout(function () {}, 1000);
		feather.replace();
		gsap.to('.loader', {
			duration: 1,
			opacity: 0,
			ease: 'power1.inOut',
			onStart: function () {
				setTimeout(function () {
					$('.loader').css('display', 'none');
				}, 3000);
				setTimeout(function () {
					gsap.fromTo(
						'.webgl',
						{
							opacity: 0,
						},
						{
							duration: 0.5,
							opacity: 1,
							ease: 'power1.inOut',
						}
					);
					gsap.fromTo(
						'.label-container',
						{
							opacity: 0,
						},
						{
							duration: 0.5,
							opacity: 1,
							ease: 'power1.inOut',
						}
					);
				}, 1250);
			},
		});
	} else {
		setTimeout(entry_loaded_check, 1000);
	}
}

$(function () {
	cnvs = $('.webgl');

	var hammertime = new Hammer(labelRenderer.domElement);
	hammertime.get('pan').set({
		direction: Hammer.DIRECTION_HORIZONTAL,
	});
	hammertime.on('pan', function (ev) {
		var speed = 0 - ev.velocity;

		if (isMobile) {
			if (ev.direction == 2) {
				if (camera.position.x <= 1) {
					gsap.to(camera.position, {
						duration: 1,
						x:
							camera.position.x +
							(speed / (window.innerWidth / 25)) * moveMultiplier,
						ease: 'power4.out',
					});
				} else {
					gsap.to(camera.position, {
						duration: 1,
						x: 1,
						ease: 'power4.out',
					});
				}
			} else if (ev.direction == 4) {
				if (camera.position.x >= -1) {
					gsap.to(camera.position, {
						duration: 1,
						x:
							camera.position.x +
							(speed / (window.innerWidth / 25)) * moveMultiplier,
						ease: 'power4.out',
					});
				} else {
					gsap.to(camera.position, {
						duration: 1,
						x: -1,
						ease: 'power4.out',
					});
				}
			}
			mobileScrolledX = camera.position.x;
		}
	});

	$(window).resize(function () {
		checkIfMobile();
	});

	$('.c').mousedown(function () {
		gsap.to($(this), {
			duration: 0.15,
			scale: 0.8,
			ease: 'power4.inOut',
		});
	});

	$('.c').mouseup(function () {
		gsap.to($(this), {
			duration: 0.15,
			scale: 1,
			ease: 'power4.inOut',
		});
	});

	function animate_default() {
		moveMultiplier = 2.5;

		$('body').removeClass('limit-scroll');

		gsap.to('.info', {
			duration: 0.5,
			ease: ease,

			onStart: function () {
				$('.info').removeClass('info-out');
			},
		});

		gsap.to('.hide-on-focus', {
			opacity: 1,
			duration: 0.5,
			ease: ease,
			delay: 1,
		});

		gsap.to('.webgl-c', {
			duration: dur,
			x: 0,
			y: 0,
			ease: ease,
		});

		gsap.to('.hs-label', {
			duration: dur - (dur - 0.5),
			delay: dur - 0.5,
			opacity: 1,
			ease: ease,
			onComplete: function () {
				$('.hs-label').css('pointer-events', 'all');
			},
		});

		gsap.to(base.position, {
			duration: dur,
			x: base_default_pos[0],
			y: base_default_pos[1],
			z: base_default_pos[2],
			ease: ease,
		});
		gsap.to(base.rotation, {
			duration: dur,
			x: base_default_rot[0],
			y: base_default_rot[1],
			z: base_default_rot[2],
			ease: ease,
		});

		if (isMobile) {
			gsap.to(camera.position, {
				duration: dur,
				x: mobileScrolledX,
				y: camera_default_pos[1],
				z: camera_default_pos[2],
				ease: ease,
			});
			gsap.to(camera.rotation, {
				duration: dur,
				x: camera_default_rot[0],
				y: camera_default_rot[1],
				z: camera_default_rot[2],
				ease: ease,
			});
		} else {
			gsap.to(camera.position, {
				duration: dur,
				x: camera_default_pos[0],
				y: camera_default_pos[1],
				z: camera_default_pos[2],
				ease: ease,
			});
			gsap.to(camera.rotation, {
				duration: dur,
				x: camera_default_rot[0],
				y: camera_default_rot[1],
				z: camera_default_rot[2],
				ease: ease,
			});
		}
	}

	$('.close-info').click(function () {
		animate_default();
	});

	var magnets = $('.magnetic');
	var strength = 0;

	magnets.each(function () {
		$(this).on('mousemove', moveMagnet);
		$(this).on('mouseout', function () {
			var magnetButton = $(this).find('.c');
			gsap.to(magnetButton, 1, { x: 0, y: 0, ease: 'power4.easeOut' });
		});
	});

	function moveMagnet(event) {
		var magnetButton = $(event.currentTarget).find('.c');
		var bounding = magnetButton.offset();

		gsap.to(magnetButton, 1, {
			x:
				((event.clientX - bounding.left) / magnetButton.width() - 0.5) *
				strength,
			y:
				((event.clientY - bounding.top) / magnetButton.height() - 0.5) *
				strength,
			ease: 'power4.easeOut',
		});
	}

	$(window).keydown(function (event) {
		if (
			(event.keyCode == 107 && event.ctrlKey == true) ||
			(event.keyCode == 109 && event.ctrlKey == true)
		) {
			event.preventDefault();
		}

		$(window).bind('mousewheel DOMMouseScroll', function (event) {
			if (event.ctrlKey == true) {
				event.preventDefault();
			}
		});
	});
});

animate();
entry_loaded_check();

$(document).on('click', 'a[href^="#"]', function (event) {
	event.preventDefault();

	$('html, body').animate(
		{
			scrollTop: $($.attr(this, 'href')).offset().top - 150,
		},
		500
	);
});

$(window).on('load', function () {
	$(window).scroll(function () {
		var scrollTop = $(window).scrollTop();

		if (scrollTop >= window.innerHeight / 2) {
			$('.actions span').css('opacity', '0');
		} else {
			$('.actions span').css('opacity', '1');
		}
	});
});

$('.read-more_tables').click(function (e) {
	e.preventDefault();
	var next = $(this).prev();
	next.toggleClass('show');
});
